import {useEffect, useMemo} from "react";
import {createBrowserHistory} from "history";
import React from "react";
import { Router } from "react-router-dom";
import {BrowserHistoryBuildOptions} from "history/createBrowserHistory";


export type BrowserRouterProps = BrowserHistoryBuildOptions & {
    children?: any
}


export const BrowserRouter = (props: BrowserRouterProps) => {
    const {children, ...options} = props
    const history = useMemo(() => {
        if (typeof window == "undefined") {
            return null;
        }
        return createBrowserHistory(options)
    }, []);

    useEffect(() => () => {
        // history.location не очищается при размонтировании из-за чего другие компоненты могут переписать историю, которая не контролируется
        history.location = null;
    }, []);

    return (
        <Router history={history}>
            {children}
        </Router>
    )
}